import { render } from "./AdelantoPersonal.vue?vue&type=template&id=2704a1e1&scoped=true"
import script from "./AdelantoPersonal.vue?vue&type=script&lang=js"
export * from "./AdelantoPersonal.vue?vue&type=script&lang=js"

import "./AdelantoPersonal.vue?vue&type=style&index=0&id=2704a1e1&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2704a1e1"]])

export default __exports__